import React, { ReactNode } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  NavigationType,
  Route,
  Router,
  Routes,
} from 'react-router-dom-v5-compat';

type Props = { children: ReactNode };

/**
 * Gives v6 the v5 context location.
 *
 * The package `CompatRouter` copies the location into its own state from a
 * `history.listen` in a layout effect, so after an async push or Back/Forward
 * v5 renders first and v6 lags one render behind. Reading the v5 location
 * during render keeps both in step.
 */
export function CompatRouter({ children }: Props) {
  const history = useHistory();
  const location = useLocation();

  return (
    <Router
      navigationType={history.action as NavigationType}
      location={location}
      navigator={history}
    >
      <Routes>
        <Route path="*" element={children} />
      </Routes>
    </Router>
  );
}
